import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/injectable/user.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogComponent } from '../../shared/components/dialog/dialog.component';
import { VERSION } from 'src/environments/version'; 
import { ChangePassword } from 'src/app/model/changePassword';
import { MatButton } from '@angular/material/button';
import { GenericErrorModalService } from 'src/app/injectable/generic-error-handling/generic-error-modal.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  version = VERSION.version;
  visible: boolean;
  password1: string;
  password2: string;
  passwordOld:string;
  changePasswordObj:ChangePassword= new ChangePassword();
  serverMessage: any = "";
  passwordState: string;
  block: boolean;
  spinner: boolean = false;
  isBackButtonVisible = false

  constructor(
    public changeService: UserService,
    public dialog: MatDialog,
    private router: Router,
    private genericErrorModalService: GenericErrorModalService
  ) { }

  @ViewChild('buttonChange',{static:false}) buttonChange:MatButton;
 
 changeInput()
 {
  if(this.password1!=this.password2)
  {
    this.buttonChange.disabled=true;
    return;
  }else{this.buttonChange.disabled=false;}
  
 }

  ngOnInit() {
    this.block = true;
    if (this.changeService.loginRoute === true) {
      this.block = false;
    } else {
      if(sessionStorage.getItem("needPasswordReset") === "true"){
        //Non permettere a utente di tornare indietro nemmeno tramite browser
        this.changeService.resetRouteBlock = true;
      }
    }
    if(sessionStorage.getItem("needPasswordReset") === "true"){
      //Cambio password richiesto da sistema, non mostrare pulsante "indietro"
      sessionStorage.setItem("needPasswordReset", "false")
    }
    else{
      //Cambio password richiesto da utente, mostrare pulsante "indietro"
      this.isBackButtonVisible = true
    }
  }

  changePassword() {
    this.spinner = true;
    this.serverMessage = new Error;
    if (this.password1 === this.password2) {
      this.changePasswordObj.newPassword=this.password1;
      this.changePasswordObj.oldPassword=this.passwordOld;
      this.passwordOld = (this.passwordOld!=sessionStorage.getItem('DataOld')?sessionStorage.getItem('DataOld'):this.passwordOld);
      sessionStorage.setItem('DataOld','');
      this.changeService.changePasssword(this.changePasswordObj).subscribe((resp) => {
        this.serverMessage.message = resp.message;
        this.openDialog();
        this.spinner = false;
      }, error => {
        this.genericErrorModalService.open('Errore nel cambio della password', error);
      })
    } else {
      this.serverMessage.message = "PAS03";
      this.openDialog();
      this.spinner = false;
    }
  }

  back() {
    this.changeService.loginRoute = false;
    this.router.navigate(['']);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '500px',
      data: { message: this.serverMessage.message }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (this.password1 === this.password2) {
        this.changeService.resetRouteBlock = false;
        this.changeService.loginRoute = false;
        this.router.navigate(['']);
      }
    });
  }

}
